import { isUndefinedOrWhiteSpace } from './string';

export const hasNoValue = (value: unknown): value is undefined | null | '' =>
    value === undefined || value === null || (typeof value === 'string' && isUndefinedOrWhiteSpace(value));

export const isObject = (value: unknown): value is object =>
    typeof value === 'object' && !Array.isArray(value) && value !== null;
